import React from "react";
import { Link } from "react-router-dom";
import { get } from "lodash";
import {
  Container,
  Navbar,
  Nav,
  Image,
  Row,
  Col,
  Dropdown,
} from "react-bootstrap";
import { ROUTES } from "../../utils";
import { IconDropDown, HeaderPopover } from "../";
import { ReactComponent as UserIcon } from "./user-icon.svg";
import { ReactComponent as VerticalTripleDots } from "./vertical-triple-dots.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { LoginMenu } from "../api-authorization/LoginMenu";
import CompanyLogo from "../../assets/company-logo.png";

const menuList = [
  {
    path: ROUTES.HOME,
    label: "Home",
    childRoutes: [
      ROUTES.COMPANY,
      ROUTES.MANAGE_COMPANY,
      ROUTES.PLAN,
      ROUTES.CREATE_PLAN,
      ROUTES.MANAGE_PLAN,
      ROUTES.MANAGE_ELIGIBILITY,
      ROUTES.MANAGE_EMPLOYEE,
      ROUTES.MANAGE_CENSUS,
      ROUTES.ENROLLMENT,
    ],
  },
  // {
  //   path: ROUTES.DASHBOARD,
  //   label: "Dashboard",
  // },
];

const Header = ({ onMenuChange, seletedRoute }) => {
  return (
    <div className="new-layout-header">
      <Row className="header-nav-row align-items-center">
        <Col xs={3} className="d-flex company-logo-new">
          <Image
            src={`${process.env.REACT_APP_LOGO_API_URL}`}
            alt="company-logo"
            width="80%"
            height="100%"
          />
        </Col>
        <Col className="d-flex justify-content-end" >        
            <div>
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic" className="no-list-icon" style={{backgroundColor:"white", borderColor:"#004dcb", color:"#004dcb"}}>
                Need Assistance?
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu Contact">
                <Dropdown.Item className="dropdown-header-item header-contact" disabled={true}>Need Assistance?</Dropdown.Item> 
                <Dropdown.Item className="dropdown-items contact-items" style={{fontSize:"14px"}} disabled={true}>
                <div>
                <FontAwesomeIcon
                      icon={faEnvelope}
                      size="lg"
                      style={{ paddingRight: "5px" }}
                      color="grey"
                    />
                    Mail Us <br/>
                    <p style={{fontSize:"12px"}}><b>payrollintegrity@my.futureplan.com</b></p>
                </div>
                </Dropdown.Item>
                <hr style={{ margin: "2px auto", borderColor: "grey", width: "200px"}} />
                <Dropdown.Item className="dropdown-items contact-items" style={{fontSize:"14px"}} disabled={true}>
                <div>
                  <FontAwesomeIcon
                      icon={faPhoneAlt}
                      size="lg"
                      style={{ paddingRight: "5px" }}
                      color="grey"
                    />
                    Call Us <br/>
                    <p style={{fontSize:"14px !important"}}><b>1-800-223-8348</b></p>
                  </div>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            </div>
        </Col>
        <Col xs={1} className="d-flex justify-content-end">
          <IconDropDown icon={<UserIcon />}>
            <HeaderPopover>
              <LoginMenu />
            </HeaderPopover>
          </IconDropDown>

          <IconDropDown icon={<VerticalTripleDots />}>
            <HeaderPopover>
              <Link to={ROUTES.DOCO_CENTER}>
                <Dropdown.Item as="button">Help</Dropdown.Item>
              </Link>
              <Link to={ROUTES.HOME}>
                <Dropdown.Item as="button">Search</Dropdown.Item>
              </Link>
            </HeaderPopover>
          </IconDropDown>
        </Col>
      </Row>
    </div>
    // <Navbar bg="light" expand="md" sticky="top" className="header-nav">
    //   <Container fluid>
    // <Row className="header-nav-row align-items-center">
    //   <Col xs={12} className="d-flex justify-content-end">
    //     <IconDropDown icon={<UserIcon />}>
    //       <HeaderPopover>
    //         <LoginMenu />
    //       </HeaderPopover>
    //     </IconDropDown>

    //     <IconDropDown icon={<VerticalTripleDots />}>
    //       <HeaderPopover>
    //         <Link to={ROUTES.DOCO_CENTER}>
    //           <Dropdown.Item as="button">Help</Dropdown.Item>
    //         </Link>
    //         <Link to={ROUTES.HOME}>
    //           <Dropdown.Item as="button">Search</Dropdown.Item>
    //         </Link>
    //       </HeaderPopover>
    //     </IconDropDown>
    //   </Col>
    // </Row>
    //   </Container>
    // </Navbar>
  );
};

export default Header;
